// import logo from "./logo.svg";
import "./LoginRegisterContainer.scss";
import Login from "../Login/Login"
import logo from "../../E-Cart.png"
import Register from "../Register/Register";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { useState } from "react";

function LoginRegisterContainer(props) {
    // view: 'login', 'register', 'forgot-password'
    const [currentView, setCurrentView] = useState('login');
    
    const navigateToLoginPage = () => {
        setCurrentView('login');
    };

    const navigateToRegisterPage = () => {
        setCurrentView('register');
    };
    
    const navigateToForgotPasswordPage = () => {
        setCurrentView('forgot-password');
    };
    return (
        <div className="login-Register-container">
            <div className="form-container">
                {/* <div className="logo">
                    <img src={logo} alt="Logo" />
                </div> */}
                {currentView === 'login' && (
                    <Login 
                        navigateToRegisterPage={navigateToRegisterPage}
                        navigateToForgotPasswordPage={navigateToForgotPasswordPage}
                        setUserAuthenticatedStatus={props.setUserAuthenticatedStatus} 
                    />
                )}
                {currentView === 'register' && (
                    <Register navigateToLoginPage={navigateToLoginPage} />
                )}
                {currentView === 'forgot-password' && (
                    <ForgotPassword navigateToLoginPage={navigateToLoginPage} />
                )}
            </div>
        </div>
    );
}

export default LoginRegisterContainer;
